<!-- PatientActionButton -->
<script setup lang="ts">
    import { usePatientActionStore } from '../../../lib/Stores/PatientActionStore';
    import { initPinia } from '../../../lib/PiniaMgr';
    import { IPatientActionAndKeyModel } from '../../../lib/Api/PatientAction';
    import { onBeforeMount, reactive, watch } from 'vue';
    import { registerRuntimeCompiler } from 'vue';
    import { TextDisplayStyle, IconTypes } from '../../../Enums/UiEnums'
    import { DatabaseIdTypes } from '../../../Enums/ChoiceEnums';
    import Icon from '../../Icon.vue';
    import XSpan from '../../HtmlWrapper/XSpan.vue';

    const patientActionStore = usePatientActionStore(initPinia());

    const props = defineProps<{
        patientActionKeyGuid?: string,
        databaseIdType?: DatabaseIdTypes,
        identifier?: number
    }>();

    const compData = reactive<{
        patientAction?: IPatientActionAndKeyModel
    }>({});

    watch(() => props.patientActionKeyGuid, (newVal, _oldVal) =>{
        getPatientActionInfo(newVal);
    });

    onBeforeMount(async ()=>{
        getPatientActionInfo(props.patientActionKeyGuid);
    });

    async function getPatientActionInfo(patientActionKeyGuid?: string)
    {
        compData.patientAction = await patientActionStore.getPatientAction(patientActionKeyGuid ?? "--InvalidGuid--");
    }

</script>

<style scoped>

    .action-button{
        text-decoration: none;
        user-select: none;
        border-radius: 0.25em;
        padding-top: 0.1em;
        padding-bottom: 0.1em;
        padding-left: 0.25em;
        padding-right: 0.25em;
        background-color: paleturquoise;
        border-color: dodgerblue;
        border-style: solid;
        border-width: 1px;
    }

    .action-button:hover
    {
        background-color: dodgerblue;
        border-style: none;
        color: white;
    }
</style>

<template>
    <template v-if="compData.patientAction?.newTab && databaseIdType && identifier">
        <XSpan style="padding-left:0.25em">
            <a class="action-button"
                    :href="`/officemd/App/Patient/Action/${compData.patientAction.actionType}/${patientActionKeyGuid}/${databaseIdType}/${identifier}`" 
                    :title="compData.patientAction.toolTipText" 
                    :target="`${patientActionKeyGuid}`">
                {{ compData.patientAction.buttonText }}
                <Icon :icon="IconTypes.PopOpen" :displayStyle="TextDisplayStyle.NoClass" />
            </a>
        </XSpan>
    </template>
</template>